// src/slices/flightFilterSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    filteredData: null,
    selectedStops: "",
    selectedDeparture: [],
    selectedAirlines: [],
    priceRange: [0, 100],
    defaultPriceRange: [0, 100],
    sortBy: ""
};

const flightFilterSlice = createSlice({
    name: 'flightFilter',
    initialState,
    reducers: {
        setFilteredData(state, action) {
            state.filteredData = action.payload;
        },
        setSortBy(state, action) {
            state.sortBy = action.payload;
        },
        setSelectedStops(state, action) {
            state.selectedStops = action.payload;
        },
        setSelectedDeparture(state, action) {
            state.selectedDeparture = action.payload;
        },
        setSelectedAirlines(state, action) {
            state.selectedAirlines = action.payload;
        },
        setPriceRange(state, action) {
            state.priceRange = action.payload;
        },
        setDefaultPriceRange(state, action) {
            // Set default price range from API to reset later
            state.defaultPriceRange = action.payload;
        },
        clearAllFilters(state, action) {
            const { oneWayFlightData } = action.payload;
            const minPrice = oneWayFlightData?.priceRange?.minPrice || 0;
            const maxPrice = oneWayFlightData?.priceRange?.maxPrice || 100;

            state.selectedStops = '';
            state.selectedDeparture = [];
            state.selectedAirlines = [];
            state.sortBy = "";
            state.priceRange = [minPrice, maxPrice];
            state.filteredData = { ...oneWayFlightData };
        },
        applyFilters(state, action) {
            const { oneWayFlightData } = action.payload;
            if (!oneWayFlightData) return;

            let filtered = oneWayFlightData?.results;
            const { selectedStops, selectedDeparture, selectedAirlines, priceRange, sortBy } = state;

            const timeRanges = {
                before_6AM: { start: 0, end: 6 },
                after6AM_12PM: { start: 6, end: 12 },
                after12PM_6PM: { start: 12, end: 18 },
                after_6PM: { start: 18, end: 24 },
            };

            // Filter by stops
            if (selectedStops.length > 0) {
                filtered = filtered.filter((flight) =>
                    selectedStops.includes(flight.stops.toString())
                );
            }

            // Filter by departure time
            if (selectedDeparture.length > 0) {
                filtered = filtered.filter((flight) => {
                    const departureTime = new Date(flight.departureTime).getHours();
                    return selectedDeparture.some((time) => {
                        const range = timeRanges[time];
                        return departureTime >= range.start && departureTime < range.end;
                    });
                });
            }

            // Filter by preferred airlines
            if (selectedAirlines.length > 0) {
                filtered = filtered.filter((flight) =>
                    selectedAirlines.includes(flight.airline)
                );
            }

            // Filter by price range
            filtered = filtered.filter((flight) => {
                const totalPrice = flight.priceOptions[0]?.totalFare;
                return totalPrice >= priceRange[0] && totalPrice <= priceRange[1];
            });

            if (sortBy === "cheapest") {
                // filtered.sort((a, b) => b.priceOptions[0]?.baseFare - a.priceOptions[0]?.baseFare);
            } else if (sortBy === "fastest") {
                filtered.sort((a, b) => a.total_duration - b.total_duration);
            }

            state.filteredData = { ...oneWayFlightData, flights: filtered };
        },
    },
});

export const { setFilteredData, setSelectedStops, setSelectedDeparture, setSelectedAirlines, setPriceRange, setDefaultPriceRange, clearAllFilters, setSortBy, applyFilters } = flightFilterSlice.actions;
export default flightFilterSlice.reducer;
